<template>
  <div class="ks-breadcrumbs">
    <span v-for="item in items">
      <span 
        v-if="item != items[0]" 
      >
        {{divider}}
      </span>
      <k-btn flat size="xxs" color="secondary"
        @click="$emit('open-link', item.href)"
        :disabled="item.href == null"
      > 
        {{item.text}}
      </k-btn>
    </span>
      </div>
</template>

<script>  
export default {
  name: 'k-breadcrumbs',
  props: {
    items: {
      type: Array,
      default: () => 
      [
        {
          text: 'text 1',
          href: 'default'
        },
        {
          text: 'text 2',
        }
      ]
    },
    divider: {
      type: String,
      default: '/'
    }
  }
}
</script>

<style>
.ks-breadcrumbs {
  font-size: 12px;
  color: lightgray;
}
.ks-breadcrumbs-link:hover:enabled {
  color: white;
}
</style>